"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HotelTrustYouScore = _interopRequireDefault(require("../HotelTrustYouScore"));

var _excluded = ["data"];

var HotelTrustYouCategoryList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelTrustYouCategoryList, props, data.map(function (_ref2) {
    var score = _ref2.score,
        category_name = _ref2.category_name,
        testimonial = _ref2.testimonial;
    return /*#__PURE__*/_react["default"].createElement(StyledItem, {
      key: category_name
    }, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, category_name, /*#__PURE__*/_react["default"].createElement(StyledScore, {
      value: score / 10
    })), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, testimonial));
  }));
});

HotelTrustYouCategoryList.propTypes = {
  className: _propTypes["default"].string,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    count: _propTypes["default"].number.isRequired,
    sentiment: _propTypes["default"].oneOf(['neg', 'neu', 'pos']),
    score: _propTypes["default"].number.isRequired,
    relevance: _propTypes["default"].number.isRequired,
    category_id: _propTypes["default"].string.isRequired,
    category_name: _propTypes["default"].string.isRequired,
    testimonial: _propTypes["default"].string.isRequired
  }).isRequired).isRequired,
  columns: _propTypes["default"].oneOf([1, 2])
};
HotelTrustYouCategoryList.defaultProps = {
  className: '',
  columns: 1
};

var StyledHotelTrustYouCategoryList = _styledComponents["default"].ul.withConfig({
  displayName: "HotelTrustYouCategoryList__StyledHotelTrustYouCategoryList",
  componentId: "sc-1c4zlbx-0"
})(["display:block;column-count:", ";column-gap:15px;"], function (props) {
  return props.columns;
});

var StyledItem = _styledComponents["default"].li.withConfig({
  displayName: "HotelTrustYouCategoryList__StyledItem",
  componentId: "sc-1c4zlbx-1"
})(["break-inside:avoid;page-break-inside:avoid;margin-bottom:10px;box-sizing:border-box;"]);

var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "HotelTrustYouCategoryList__StyledTitle",
  componentId: "sc-1c4zlbx-2"
})(["font-size:14px;::first-letter{text-transform:uppercase;}"]);

var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelTrustYouCategoryList__StyledDescription",
  componentId: "sc-1c4zlbx-3"
})(["font-size:12px;color:", ";"], function (props) {
  return props.theme.colors.greyLight;
});

var StyledScore = (0, _styledComponents["default"])(_HotelTrustYouScore["default"]).withConfig({
  displayName: "HotelTrustYouCategoryList__StyledScore",
  componentId: "sc-1c4zlbx-4"
})(["margin-left:10px;"]);
HotelTrustYouCategoryList.Item = StyledItem;
HotelTrustYouCategoryList.Title = StyledTitle;
HotelTrustYouCategoryList.Description = StyledDescription;
var _default = HotelTrustYouCategoryList;
exports["default"] = _default;